var typographyStyles = theme => {
  return {
    'body, .body': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size0,
      lineHeight: theme.typography.lineHeight2,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size1,
        lineHeight: theme.typography.lineHeight3
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size2,
        lineHeight: theme.typography.lineHeight3
      }
    },
    '.body-large': {
      fontFamily: theme.typography.family0,
      lineHeight: theme.typography.lineHeight2,
      fontSize: theme.typography.size1,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size2,
        lineHeight: theme.typography.lineHeight3
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size3,
        lineHeight: theme.typography.lineHeight3
      }
    },
    // Headings
    'h1, .title-large, .title-large--light': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size8,
      fontWeight: theme.typography.weight3,
      lineHeight: theme.typography.lineHeight8,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontFamily: theme.typography.family0,
        fontSize: theme.typography.size10,
        lineHeight: theme.typography.lineHeight10
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontFamily: theme.typography.family0,
        fontSize: theme.typography.size11,
        lineHeight: theme.typography.lineHeight11
      }
    },
    'h2, .title-medium, .title-medium--light': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size6,
      fontWeight: theme.typography.weight3,
      lineHeight: theme.typography.lineHeight6,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size9,
        lineHeight: theme.typography.lineHeight9
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontFamily: theme.typography.family0,
        fontSize: theme.typography.size10,
        lineHeight: theme.typography.lineHeight10
      }
    },
    'h3, .title-regular, .title-regular--light': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size5,
      fontWeight: theme.typography.weight3,
      lineHeight: theme.typography.lineHeight5,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size7,
        lineHeight: theme.typography.lineHeight7
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size9,
        lineHeight: theme.typography.lineHeight9
      }
    },
    'h4, .title-small, .title-small--light': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size4,
      fontWeight: theme.typography.weight3,
      lineHeight: theme.typography.lineHeight4,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size5,
        lineHeight: theme.typography.lineHeight5
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size7,
        lineHeight: theme.typography.lineHeight7
      }
    },
    'h5, .subtitle-large, .subtitle-large--light': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size3,
      fontWeight: theme.typography.weight3,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size4,
        lineHeight: theme.typography.lineHeight4
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size5,
        lineHeight: theme.typography.lineHeight5
      }
    },
    'h6, .subtitle-regular, .subtitle-regular--light': {
      fontFamily: theme.typography.family0,
      fontWeight: theme.typography.weight3,
      lineHeight: theme.typography.lineHeight2,
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size3,
        lineHeight: theme.typography.lineHeight3
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size4,
        lineHeight: theme.typography.lineHeight4
      }
    },
    '.font-medium': {
      fontFamily: theme.typography.family0,
      fontWeight: theme.typography.weight4
    },
    // Helpers classes
    '.caption': {
      fontSize: theme.typography.size1,
      lineHeight: theme.typography.lineHeight2
    },
    '.caption-small': {
      fontSize: theme.typography.size0,
      lineHeight: theme.typography.lineHeight1
    },
    '.label': {
      fontFamily: theme.typography.family0,
      lineHeight: theme.typography.lineHeight2
    },
    '.label-small': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size0,
      lineHeight: theme.typography.lineHeight1
    },
    '.overline-regular': {
      fontFamily: theme.typography.family0,
      fontSize: theme.typography.size0,
      lineHeight: theme.typography.lineHeight1,
      textTransform: 'uppercase',
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size1,
        lineHeight: theme.typography.lineHeight2
      }
    },
    '.overline-large': {
      fontFamily: theme.typography.family0,
      lineHeight: theme.typography.lineHeight2,
      textTransform: 'uppercase',
      ["@media (min-width: ".concat(theme.layout.smMin, ")")]: {
        fontSize: theme.typography.size3,
        lineHeight: theme.typography.lineHeight3
      },
      ["@media (min-width: ".concat(theme.layout.lgMin, ")")]: {
        fontSize: theme.typography.size4,
        lineHeight: theme.typography.lineHeight4
      }
    },
    // future: customize reset css via props
    sub: {
      fontSize: 'smaller',
      verticalAlign: 'sub'
    },
    sup: {
      fontSize: 'smaller',
      verticalAlign: 'super'
    }
  };
};
export default typographyStyles;